var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKadenaTorus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 387,
    height: 150.207,
    viewBox: "0 0 387 150.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.015,
    y1: 0.5,
    x2: 0.962,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.019,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.151,
    stopColor: "#1174b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.282,
    stopColor: "#1a91cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#21a6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#25b2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#27b7e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.07,
    y1: 0.257,
    x2: 0.527,
    y2: 0.57,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#054f9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#0b62ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1581c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#1d98d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    stopColor: "#22a9dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#25b3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#27b7e6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_54109",
    "data-name": "Group 54109",
    transform: "translate(-152 -325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54107",
    "data-name": "Group 54107",
    transform: "translate(124.064 294.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51459",
    "data-name": "Group 51459",
    transform: "translate(164.218 30.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34419",
    "data-name": "Path 34419",
    d: "M125.8,28.112h12.819V46.79l17.817-18.678h15.208L151.8,48.808l21,30.864H157.881L142.962,57.389l-4.346,4.543V79.671H125.8Z",
    transform: "translate(-125.797 -28.112)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34420",
    "data-name": "Path 34420",
    d: "M151.59,63.283c0-8.185,6.518-10.649,14.2-11.661,6.952-.871,9.415-1.593,9.415-4.128,0-2.393-1.522-3.984-5.07-3.984-3.767,0-5.65,1.667-6.013,4.78H153.255c.291-6.88,5.576-12.747,16.8-12.747,5.578,0,9.343,1.015,12.023,3.041,3.187,2.317,4.707,5.939,4.707,10.574V67.846c0,2.97.289,4.635,1.3,5.287v.507H176.648a10.332,10.332,0,0,1-1.23-4.128h-.145c-2.172,3.113-5.431,5.068-11.009,5.068C156.877,74.579,151.59,70.6,151.59,63.283Zm23.9-2.9V55.967a28.528,28.528,0,0,1-6.085,1.958c-4.563,1.011-6.445,2.17-6.445,4.994,0,2.969,2.174,4.128,5.071,4.128C172.448,67.047,175.49,64.37,175.49,60.386Z",
    transform: "translate(-104.314 -22.081)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34421",
    "data-name": "Path 34421",
    d: "M173.467,61.215c0-11.539,6.663-19.544,16.224-19.544,5.215,0,8.183,2.164,10.356,5.264h.217V28.112h11.8V79.676h-11.3V74.7h-.144a12.227,12.227,0,0,1-10.937,6.13C180.2,80.83,173.467,73.546,173.467,61.215Zm27.089,0c0-6.2-2.537-10.673-7.678-10.673-4.709,0-7.461,4.327-7.461,10.527,0,6.422,2.752,10.459,7.315,10.459C197.658,71.527,200.555,67.271,200.555,61.215Z",
    transform: "translate(-86.097 -28.112)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34422",
    "data-name": "Path 34422",
    d: "M197.109,55.06c0-11.084,7.75-19.556,19.048-19.556a18.235,18.235,0,0,1,12.674,4.635c4.419,4.056,6.591,10.5,6.519,18.034H208.7c.726,5,3.478,8.111,8.33,8.111,3.113,0,5.143-1.374,6.156-3.692H234.7a15.1,15.1,0,0,1-6.228,8.763,19.627,19.627,0,0,1-11.589,3.4C204.641,74.76,197.109,66.284,197.109,55.06ZM223.4,51.147c-.435-4.417-3.187-7.243-7.026-7.243-4.491,0-6.808,2.826-7.6,7.243Z",
    transform: "translate(-66.406 -22.113)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34423",
    "data-name": "Path 34423",
    d: "M220.617,36.591h11.37v5.068h.217c2.752-3.981,6.3-6.155,11.443-6.155,8.111,0,12.893,5.793,12.893,14.05V73.673H244.734V51.943c0-3.911-1.956-6.589-5.793-6.589-3.911,0-6.519,3.259-6.519,7.822v20.5h-11.8Z",
    transform: "translate(-46.818 -22.113)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34424",
    "data-name": "Path 34424",
    d: "M242.669,63.283c0-8.185,6.517-10.649,14.2-11.661,6.952-.871,9.413-1.593,9.413-4.128,0-2.393-1.52-3.984-5.068-3.984-3.767,0-5.652,1.667-6.013,4.78H244.334c.289-6.88,5.576-12.747,16.8-12.747,5.578,0,9.343,1.015,12.023,3.041,3.185,2.317,4.707,5.939,4.707,10.574V67.846c0,2.97.289,4.635,1.3,5.287v.507H267.727a10.356,10.356,0,0,1-1.233-4.128h-.144c-2.174,3.113-5.432,5.068-11.009,5.068C247.954,74.579,242.669,70.6,242.669,63.283Zm23.9-2.9V55.967a28.528,28.528,0,0,1-6.085,1.958c-4.561,1.011-6.445,2.17-6.445,4.994,0,2.969,2.172,4.128,5.07,4.128C263.527,67.047,266.569,64.37,266.569,60.386Z",
    transform: "translate(-28.453 -22.081)",
    fill: "#27b7e6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_51460",
    "data-name": "Group 51460",
    transform: "translate(27.936 30.777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34425",
    "data-name": "Path 34425",
    d: "M112.5,28.112H82.159L46.446,65.587V96.806Z",
    transform: "translate(-20.794 -28.112)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4909",
    "data-name": "Rectangle 4909",
    width: 25.652,
    height: 103.199,
    transform: "translate(0 0)",
    fill: "#27b7e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34426",
    "data-name": "Path 34426",
    d: "M113.156,123.869,71,61.847,53.844,79.691l29.529,44.178Z",
    transform: "translate(-19.125 -20.669)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_54108",
    "data-name": "Group 54108",
    transform: "translate(-394 78)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_54084",
    "data-name": "Group 54084",
    transform: "translate(546 375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38815",
    "data-name": "Path 38815",
    d: "M70.493,42.369a14.176,14.176,0,0,0,0-9.079,10.2,10.2,0,0,0-2.1-3.494,9.27,9.27,0,0,0-3.252-2.241,10.793,10.793,0,0,0-4.181-.786,10.619,10.619,0,0,0-4.172.8A9.434,9.434,0,0,0,53.542,29.8a10.137,10.137,0,0,0-2.1,3.488,14.176,14.176,0,0,0,0,9.079,10.133,10.133,0,0,0,2.1,3.488,9.325,9.325,0,0,0,3.245,2.232,11.491,11.491,0,0,0,8.353,0,9.335,9.335,0,0,0,3.252-2.232A10.14,10.14,0,0,0,70.493,42.369ZM69,33.755a12.4,12.4,0,0,1,.612,4.068A12.365,12.365,0,0,1,69,41.9a8.688,8.688,0,0,1-1.771,3.049,7.5,7.5,0,0,1-2.753,1.913,9.782,9.782,0,0,1-7.035,0,7.586,7.586,0,0,1-2.753-1.913A8.717,8.717,0,0,1,52.908,41.9a13.385,13.385,0,0,1,0-8.127,8.712,8.712,0,0,1,1.783-3.07,7.681,7.681,0,0,1,2.753-1.919,9.66,9.66,0,0,1,7.035,0A7.592,7.592,0,0,1,67.235,30.7,8.7,8.7,0,0,1,69,33.755Z",
    transform: "translate(-28.527 -26.769)",
    fill: "#0364ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38816",
    "data-name": "Path 38816",
    d: "M117.611,49.106a.2.2,0,0,0,.16-.325l-7.116-9.242a2.432,2.432,0,0,0-.652-.614,8.919,8.919,0,0,0,2.539-.669,6.409,6.409,0,0,0,1.923-1.29,5.426,5.426,0,0,0,1.217-1.842,6.091,6.091,0,0,0,.425-2.312,5.248,5.248,0,0,0-1.851-4.335A8.737,8.737,0,0,0,108.72,27h-5.28a.2.2,0,0,0-.2.2V48.9a.2.2,0,0,0,.2.2H104.6a.2.2,0,0,0,.2-.2V39.311a.2.2,0,0,1,.2-.2h2.607a3.76,3.76,0,0,1,.539.034,1.263,1.263,0,0,1,.378.1.96.96,0,0,1,.3.193,2.287,2.287,0,0,1,.25.307l6.875,8.968a.861.861,0,0,0,.324.307.967.967,0,0,0,.432.086Zm-6.563-11.538a8.5,8.5,0,0,1-2.551.353H105a.2.2,0,0,1-.2-.2V28.467a.2.2,0,0,1,.2-.2h3.723a7.064,7.064,0,0,1,4.342,1.142,4.123,4.123,0,0,1,1.488,3.5,5.1,5.1,0,0,1-.408,2.079,4.341,4.341,0,0,1-1.191,1.578A5.394,5.394,0,0,1,111.048,37.568Z",
    transform: "translate(-58.095 -26.899)",
    fill: "#0364ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38817",
    "data-name": "Path 38817",
    d: "M150.324,47.7a6.8,6.8,0,0,0,2.8-.546,6.022,6.022,0,0,0,2.087-1.519,6.688,6.688,0,0,0,1.308-2.292,8.72,8.72,0,0,0,.444-2.844V27.3a.3.3,0,0,1,.3-.3h.953a.3.3,0,0,1,.3.3V40.5a9.828,9.828,0,0,1-.566,3.374,8.067,8.067,0,0,1-1.631,2.73,7.525,7.525,0,0,1-2.583,1.84,9.151,9.151,0,0,1-6.838,0,7.489,7.489,0,0,1-2.583-1.84,8.03,8.03,0,0,1-1.631-2.73,9.828,9.828,0,0,1-.566-3.374V27.3a.3.3,0,0,1,.3-.3h.959a.3.3,0,0,1,.3.3V40.48a8.707,8.707,0,0,0,.45,2.847,6.766,6.766,0,0,0,1.3,2.292,5.983,5.983,0,0,0,2.077,1.534A6.707,6.707,0,0,0,150.324,47.7Z",
    transform: "translate(-79.979 -26.899)",
    fill: "#0364ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38818",
    "data-name": "Path 38818",
    d: "M197.275,29.871a.424.424,0,0,1-.391.261.868.868,0,0,1-.507-.282,6.807,6.807,0,0,0-.838-.614,6.312,6.312,0,0,0-1.324-.632,6.554,6.554,0,0,0-4,.031,4.272,4.272,0,0,0-1.482.921,3.9,3.9,0,0,0-.911,1.345,4.223,4.223,0,0,0-.3,1.6,3.3,3.3,0,0,0,.458,1.817,4.2,4.2,0,0,0,1.214,1.228,7.946,7.946,0,0,0,1.715.847c.638.227,1.3.454,1.97.679s1.333.473,1.97.74a7.175,7.175,0,0,1,1.715,1.016,4.7,4.7,0,0,1,1.214,1.5,4.828,4.828,0,0,1,.458,2.223,7.077,7.077,0,0,1-.452,2.557,5.993,5.993,0,0,1-1.339,2.084,6.279,6.279,0,0,1-2.144,1.4,7.717,7.717,0,0,1-2.9.509,8.115,8.115,0,0,1-3.643-.755,8.593,8.593,0,0,1-2.472-1.849.392.392,0,0,1-.04-.476l.263-.416a.528.528,0,0,1,.422-.23.6.6,0,0,1,.349.184l.513.448c.2.181.443.374.725.583a5.809,5.809,0,0,0,.98.58,6.74,6.74,0,0,0,2.933.633,6.178,6.178,0,0,0,2.268-.39,4.925,4.925,0,0,0,1.679-1.074,4.5,4.5,0,0,0,1.047-1.6,5.332,5.332,0,0,0,.365-1.977,3.525,3.525,0,0,0-.462-1.888,4.016,4.016,0,0,0-1.214-1.228,7.877,7.877,0,0,0-1.712-.832c-.641-.224-1.3-.442-1.973-.657s-1.33-.451-1.97-.718a6.772,6.772,0,0,1-1.715-1.013,4.636,4.636,0,0,1-1.214-1.535,5.129,5.129,0,0,1-.462-2.314,5.582,5.582,0,0,1,.407-2.094,5.247,5.247,0,0,1,1.193-1.777,5.839,5.839,0,0,1,1.943-1.228A7,7,0,0,1,192.245,27a7.916,7.916,0,0,1,2.984.534,7.1,7.1,0,0,1,2.2,1.432.388.388,0,0,1,.073.461Z",
    transform: "translate(-104.207 -26.899)",
    fill: "#0364ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38819",
    "data-name": "Path 38819",
    d: "M2.077,27A2.073,2.073,0,0,0,0,29.07V31.48a2.074,2.074,0,0,0,2.077,2.07H5.754V47.037a2.073,2.073,0,0,0,2.077,2.07h2.42a2.074,2.074,0,0,0,2.078-2.07V29.07A2.073,2.073,0,0,0,10.252,27H2.077Z",
    transform: "translate(0 -26.899)",
    fill: "#0364ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38820",
    "data-name": "Path 38820",
    d: "M35.244,33.55a3.275,3.275,0,1,0-3.288-3.275A3.281,3.281,0,0,0,35.244,33.55Z",
    transform: "translate(-17.983 -26.899)",
    fill: "#0016de"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKadenaTorus);
export default __webpack_public_path__ + "static/media/kadena-torus.9d812150.svg";
export { ForwardRef as ReactComponent };